import React from 'react';
import Allergen from './Allergen';

export default function Allergens(props) {
    const { allergens } = props;

    let total = allergens.length;

    return (
        <span className="allergens font-bold">
            {0 === allergens.length ?
                ("No allergens.") :
                (allergens.map((allergen, index) => <Allergen allergen={allergen} total={total} index={index} key={index} />))}
        </span>
    );
}
